import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppRoutingModule } from './app.routing.module';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { PublicInterceptor } from './services/public.interceptor';
import { PrivateInterceptor } from './services/private.interceptor';
import { AppConfigProvider } from './app-config.provider';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalIconComponent } from './theme/components/modal-icon/modal-icon.component';
import { FeatherModule } from 'angular-feather';
import {
  TrendingUp,
  ArrowRightCircle,
  ArrowLeft,
  FileText,
  List,
  Info,
  Phone,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  Calendar,
  File,
  CheckCircle,
  Trash2,
  AlertTriangle
} from 'angular-feather/icons';
import { DialogService } from './services/dialog/dialog.service';
import { PermissionGuard } from './services/permissionGuard.interceptor';

const icons = {
  TrendingUp,
  ArrowRightCircle,
  ArrowLeft,
  FileText,
  List,
  Info,
  Phone,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  Calendar,
  File,
  CheckCircle,
  Trash2,
  AlertTriangle
};
import { DashboardModule } from './modules/private/modules/dashboard/dashboard.module';
import { ModalIconCustomComponent } from './theme/components/modal-icon-custom/modal-icon-custom.component';
import { DialogServiceCustom } from './services/dialog-custom/dialog-custom.service';
import { ModalDebitoResumenComponent } from './theme/components/modal-debito-resumen/modal-debito-resumen.component';
import { DialogServiceDebito } from './services/dialog-debito/dialog-debito.service';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';

@NgModule({
    declarations: [AppComponent,
        ModalIconComponent, ModalIconCustomComponent, ModalDebitoResumenComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        StoreDevtoolsModule.instrument({
            maxAge: 10,
            logOnly: environment.production, // Restrict extension to log-only mode
        }),
        RecaptchaFormsModule,
        MatDialogModule,
        FeatherModule.pick(icons),
        DashboardModule,
        GoogleTagManagerModule.forRoot({
            id: "GTM-KK8P75Q" //"GTM-WVV8PD4"
        })
    ],
    exports: [RecaptchaModule, RecaptchaFormsModule],
    providers: [
        AppConfigProvider,
        { provide: HTTP_INTERCEPTORS, useClass: PublicInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: PrivateInterceptor, multi: true },
        PermissionGuard,
        DialogService,
        DialogServiceCustom,
        DialogServiceDebito
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
